import { render, staticRenderFns } from "./LabelAbbreviations.vue?vue&type=template&id=89e1fea6&scoped=true"
import script from "./LabelAbbreviations.vue?vue&type=script&lang=js"
export * from "./LabelAbbreviations.vue?vue&type=script&lang=js"
import style0 from "./LabelAbbreviations.vue?vue&type=style&index=0&id=89e1fea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e1fea6",
  null
  
)

export default component.exports